import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import useBroadcastUnsubscribe from '../../hooks/useBroadcastUnsubscribe';
import Status from '../../components/global/Status';
import ContentWrap from '../../components/global/ContentWrap';
import { getAsset } from '../../util/assets';
import { accountProfileById } from '../../apps/web-gallery/views/UserPage/graphql';

const BroadcastUnsubscribeView = () => {
  const { onUnsubscribe, loading } = useBroadcastUnsubscribe();
  const [unsubscribed, setUnsubscribed] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const orgAccountId = searchParams.get('orgAccountId');
  const emailAddress = searchParams.get('emailAddress');

  const { data: { accountProfile } = {} } = useQuery(accountProfileById, {
    variables: { id: orgAccountId },
    skip: !orgAccountId,
    fetchPolicy: 'cache-first',
  });

  const organizationName =
    accountProfile?.organization_name ||
    accountProfile?.name ||
    'this organization';

  const handleUnsubscribe = async () => {
    try {
      setError(null);
      const input = {
        org_account_id: orgAccountId,
        email_address: emailAddress,
      };

      const result = await onUnsubscribe(input);

      if (result.success) {
        setUnsubscribed(true);
      }
    } catch (err) {
      setError('Failed to unsubscribe. Please try again.');
    }
  };

  if (unsubscribed) {
    return (
      <div>
        <Helmet>
          <title>Unsubscribed &ndash; Waldo</title>
        </Helmet>

        <Status status={200}>
          <div className="wrapper-main">
            <div className="content-wrap content-wrap-gray">
              <ContentWrap size="sm">
                <div className="text-center">
                  <h2 className="mb-3">You&rsquo;re All Set!</h2>
                  <img
                    width="100px"
                    src={getAsset('/waldo-icon.svg')}
                    alt="Waldo Icon"
                    className="mb-3"
                  />

                  <p className="text-md">
                    You have been successfully unsubscribed. You will not be
                    receiving any more notifications from{' '}
                    <strong>{organizationName}</strong>.
                  </p>
                </div>
              </ContentWrap>
            </div>
          </div>
        </Status>
      </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>Unsubscribe &ndash; Waldo</title>
      </Helmet>

      <Status status={200}>
        <div className="wrapper-main">
          <div className="content-wrap content-wrap-gray">
            <ContentWrap size="sm">
              <div className="text-center">
                <h2 className="mb-3">Sorry to see you go</h2>
                <img
                  width="100px"
                  src={getAsset('/waldo-icon-error.svg')}
                  alt="Waldo Icon"
                  className="mb-3"
                />

                <p className="text-md mb-3">
                  Click the button below to unsubscribe from receiving any more
                  notifications from <strong>{organizationName}</strong>.
                </p>

                {error && (
                  <div className="broadcast-unsubscribe-view__error mb-3">
                    {error}
                  </div>
                )}

                <button
                  onClick={handleUnsubscribe}
                  disabled={loading}
                  className="broadcast-unsubscribe-view__button btn btn-primary"
                >
                  {loading ? 'Unsubscribing...' : 'Unsubscribe'}
                </button>
              </div>
            </ContentWrap>
          </div>
        </div>
      </Status>
    </div>
  );
};

export default BroadcastUnsubscribeView;
